import React from "react";
import { Link } from "react-router-dom";
import { Star, Truck, MapPin, SealCheck } from "@phosphor-icons/react";

export default function VendorCard({ vendor }) {
  const badges = vendor.badges || [];
  return (
    <Link
      to={`/vendors/${vendor.slug}`}
      data-testid="vendor-card"
      className="group relative flex flex-col bg-white rounded-2xl border border-[#E5E2D9] transition-all duration-300 hover:-translate-y-1 hover:border-[#D1CEC5] hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] overflow-hidden"
    >
      <div className="w-full aspect-[4/3] bg-[#F2EFE9] overflow-hidden">
        <img
          src={vendor.cover_image_url}
          alt={vendor.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
          loading="lazy"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-2 mb-2">
          {badges.includes("Verified Vendor") && (
            <span className="chip-success">
              <SealCheck size={12} weight="fill" /> Verified
            </span>
          )}
          {badges.includes("Top Rated") && (
            <span className="chip-warning">
              <Star size={12} weight="fill" /> Top rated
            </span>
          )}
        </div>
        <h3 className="font-heading font-bold text-lg tracking-tight leading-tight mb-1">{vendor.name}</h3>
        <p className="text-xs text-[#5C5C54] line-clamp-2 mb-3">{vendor.description}</p>
        <div className="flex items-center gap-3 text-xs text-[#5C5C54]">
          {vendor.ratings_count >= 5 && (
            <span className="flex items-center gap-1 text-[#1A1A18] font-semibold">
              <Star size={14} weight="fill" className="text-[#E4A951]" />
              {vendor.ratings_avg?.toFixed(1)} <span className="text-[#5C5C54] font-medium">({vendor.ratings_count})</span>
            </span>
          )}
          <span className="flex items-center gap-1">
            <Truck size={14} weight="duotone" />
            {vendor.delivery_config?.nationwide_shipping_enabled ? "UK-wide" : "Local only"}
          </span>
          <span className="flex items-center gap-1">
            <MapPin size={14} weight="duotone" />
            {vendor.delivery_config?.base_postcode}
          </span>
        </div>
      </div>
    </Link>
  );
}
